import { NgModule, InjectionToken } from '@angular/core';

/* Constants */
export const CONSTANTS_VALUE = {
  appTitle: 'ImmoGIS',
  maxRecordCount: 1000,
  queryParams: {
    bottomPanel: {
      status: 'bottom-panel',
    },
    selection: {
      selected: 'sel',
    },
    filters: {
      name: 'f',
    },
    justMine: {
      name: 'mine',
    },
    security: {
      user: 'u',
    },
    wkSelection: {
      selected: 'wk-sel',
      selectedTab: 'wk-tab',
    },
    mode: {
      name: 'mode',
    },
  },
  agGrid: {
    columnDef: {
      debounceTime: 500,
    },
    emptyFilterValue: '.',
    selectAll: '(Select All)',
  },

  UI: {
    mainMenuHeight: 110,
    bottomListSmallHeight: 400,
    bottomListMinHeight: 25,
    doubleClickDebounceTime: 300,
  },

  ENVIRONMENT: {
    GSHARP_SERVER: {
      GEO: 'geo.sbb.ch',
      GEO_INT: 'geo-int.sbb.ch',
      GEO_DEV: 'geo-dev.sbb.ch',
    },
    ROLES: {
      PROD: 'PROD',
      INT: 'INT',
    },
  },
  /*
    Hier kommen alle App Konstansten. Achtung Konstanten sind keine Configs
   */
  NOTIFICATION_TIMEOUT: {
    SECONDS_3: 300,
    SECONDS_5: 500,
    SECONDS_10: 1000,
  },
  ARBEITSBEREICH_TYPE: {
    TYPE: 'ALTLASTTYP',
  },
  ARBEITSBEREICHE: {
    DENKMALPFLEGE: 'denkmalpflege',
  },
  POPUP_IDS: {
    POPUP_ID: 'popup',
    TOOLTIP_POPUP_ID: 'toolTipPopUpId',
  },
  WIDGET_ID: {
    BaseMapSwitchComponent: 'BaseMapSwitchComponent',
    UserComponent: 'UserComponent',
    LegendComponent: 'LegendComponent',
    LayerControlComponent: 'LayerControlComponent',
    DetailViewComponent: 'DetailViewComponent',
    AppInfoComponent: 'AppInfoComponent',
    DevInfoComponent: 'DevInfoComponent',
    MassStabSliderComponent: 'MassStabSliderComponent',
    DrawComponent: 'DrawComponent',
    PrintComponent: 'PrintComponent',
    GoToComponent: 'GoToComponent',
    MeasureComponent: 'MeasureComponent',
    SearchParzelleComponent: 'SearchParzelleComponent',
    SearchParzelleCHComponent: 'SearchParzelleCHComponent',
    GeoPortaleComponent: 'GeoPortaleComponent',
    ShareComponent: 'ShareComponent',
    SearchHektometerComponent: 'SearchHektometerComponent',
    GoogleMapsComponent: 'GoogleMapsComponent'
  },
  CURSOR: {
    default: 'default',
    wait: 'wait',
    crosshair: 'crosshair',
  },
  FIELD_TYPE: {
    selectbox: 'select',
    radiobutton: 'radio',
    checkbox: 'check',
    datepicker: 'date',
    textview: 'text-view',
    reportbutton: 'reportbutton',
    groupfields: 'groupfields',
    textviewarea: 'textviewarea',
    textviewbp: 'textviewbp',
    dmsimage: 'dmsimage',
  },
  HTTP_STATUS: {
    NO_CONTENT_204: 204,
    NOT_MODIFIED_304: 304,
    BAD_REQUEST_400: 400,
    UNAUTHORIZED_401: 401,
    FORBIDDEN_403: 403,
    NOT_FOUND_404: 404,
    METHOD_NOT_ALLOWED_405: 405,
    INTERNAL_SERVER_ERROR_500: 500,
    SBB_LOGIN_ERROR: 999,
    ESRI_JS_API_LOAD_ERROR: 998,
  },
  LAYER_ERROR: {
    COUNT_FEATURES_FROM_LAYER_FAILED: 'COUNT_FEATURES_FROM_LAYER_FAILED',
    GET_FEATURES_FROM_LAYER_FAILED: 'GET_FEATURES_FROM_LAYER_FAILED',
    GET_FEATURES_FROM_LAYER_WITH_GEOMETRY: 'GET_FEATURES_FROM_LAYER_WITH_GEOMETRY',
    GET_FEATURES_FROM_RELATION_TABLE: 'GET_FEATURES_FROM_RELATION_TABLE',
    GET_FIELDS_FROM_LAYER: 'GET_FIELDS_FROM_LAYER',
  },
  CARDINALITY: {
    MANY_TO_MANY: 'esriRelCardinalityManyToMany',
  },
  FILTER_TYPE: {
    TEXT: 'TEXT',
    SELECT: 'SELECT',
    DATE: 'DATE',
  },
  SKETCH_GEOMETRY_SERVICE: {
    PRINT_GRAPHIC_LAYER_ID: 'print',
  },
  TOOL_EVENT_TYPE: {
    MOVE_START: 'move-start',
    MOVE_STOP: 'move-stop',
    ROTATE_STOP: 'rotate-stop',
    COMPLETE: 'complete',
    CANCEL: 'cancel',
    RESHAPE_STOP: 'reshape-stop',
    SCALE_STOP: 'scale-stop',
    MOVE: 'move',
  },
  TOOL_TYPE: {
    MOVE: 'move',
    RESHAPE: 'reshape',
    TRANSFORM: 'transform',
  },
  ESRI_GEOMETRY_TYPE: {
    POLYGON: 'polygon',
    POLYLINE: 'polyline',
    POINT: 'point',
  },
  APP_URL_PARAMS: {
    DEFAULT_SCALE: 2000,
    FUNCTIONS: {
      ZOOM_TO_WINDOW_AREA: 'ZoomToWindowArea',
      ZOOM_TO_POINT: 'ZoomToPoint',
    },
    PARAMETER_NAMES: {
      FUNCTION: 'func',
      EASTING1: 'easting1',
      EASTING2: 'easting2',
      NORTHING1: 'northing1',
      NORTHING2: 'northing2',
      SCALE: 'scale',
      WORKSPACE: 'workspace',
    },
  },
  SEARCH_GRAPHIC_TIMEOUT: {
    MINUTES_2: 120000,
  },
  GRAPHIC_TYPE: {
    FLASH_POINT: 'flashpoint',
    IMMORAIL_POINT: 'immorailpoint',
    ESRi_SEARCH_POINT: 'esrisearchPoint',
  },
  VERKAUFS_OBJEKT: {
    FIELDS_TO_BE_UPDATED: [
      'KM_ANF',
      'KM_ENDE',
      'LINIE',
      'FLAECHE_BERECHNET',
      'NORTHING',
      'EASTING',
    ],
  },
};

/* Create injection token */
export let CONSTANTS = new InjectionToken('app.constant');

/* Export module */
@NgModule({
  providers: [
    {
      provide: CONSTANTS,
      useValue: CONSTANTS_VALUE,
    },
  ],
})
export class ConstantsModule {}
